<template>
    <div class="registration-details">
        <div>
            <h2>
                {{ $t('support.registrationDetails.header')
                }}<setup-state :setupStatus="registration.setupStatus"></setup-state>
            </h2>
            <div class="ct-row">
                <div class="product">
                    <h3>{{ $t('support.table.product') }}</h3>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.table.product') }}</b></span
                            >
                            <span class="content">{{ registration.product }}</span>
                        </li>
                    </ul>
                </div>
                <div class="contact-infos">
                    <h3>{{ $t('support.registrationDetails.contactData') }}</h3>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.name') }}</b></span
                            >
                            <span class="content"
                                >{{ $t('appellation.' + registration.appellation) }} {{ registration.firstName }}
                                {{ registration.lastName }}</span
                            >
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.email') }}</b></span
                            >
                            <span class="content">{{ registration.email }}</span>
                            <a target="_blank" :href="'https://support.church.tools/search/?q=' + registration.email">{{
                                $t('support.registrationDetails.linkfreescout')
                            }}</a>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.phone') }}</b></span
                            >
                            <span class="content">{{ registration.phone }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.registerLanguage') }}</b></span
                            >
                            <span class="content">{{ registration.registrationLanguage }}</span>
                        </li>
                    </ul>
                </div>
                <div class="church-infos">
                    <h3>{{ $t('support.registrationDetails.churchData') }}</h3>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.churchName') }}</b></span
                            >
                            <span class="content">{{ registration.churchName }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.city') }}</b></span
                            >
                            <span class="content">{{ registration.city }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.country') }}</b></span
                            >
                            <span class="content">{{ registration.countryCode }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.baseLanguage') }}</b></span
                            >
                            <span class="content">{{ registration.baseLanguage }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.instanceName') }}</b></span
                            >
                            <span class="content">https://{{ registration.siteName }}.church.tools</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.website') }}</b></span
                            >
                            <span class="content">{{ registration.website }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="ct-row">
                <div class="infos">
                    <h3>{{ $t('support.registrationDetails.furtherInformation') }}</h3>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.heardFrom') }}</b></span
                            >
                            <span class="content">{{ registration.heardFrom }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.discount') }}</b></span
                            >
                            <span class="content">{{ registration.discountCode }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.cta') }}</b></span
                            >
                            <span class="content">{{ registration.cta }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.infomails') }}</b></span
                            >
                            <span class="content">{{ registration.infomails }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.newsletter') }}</b></span
                            >
                            <span class="content">{{ registration.newsletter }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.license') }}</b></span
                            >
                            <span class="content">{{ registration.licenseKey }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.created') }}</b></span
                            >
                            <span class="content">{{ registration.created | formatDate }}</span>
                            <span class="title left-margin"
                                ><b>{{ $t('support.registrationDetails.lastupdate') }}</b></span
                            >
                            <span class="content">{{ registration.last_update | formatDate }}</span>
                        </li>
                        <li class="list-group-item">
                            <span class="title"
                                ><b>{{ $t('support.registrationDetails.userAgent') }}</b></span
                            >
                            <span class="content">{{ registration.userAgent }}</span>
                        </li>
                    </ul>
                </div>
                <div class="logs">
                    <h3>{{ $t('support.registrationDetails.logs') }}</h3>
                    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                        <div class="panel panel-default" v-for="(log, index) in registration.logs">
                            <div class="panel-heading" role="tab" id="headingOne">
                                <h4 class="panel-title">
                                    <a
                                        role="button"
                                        data-toggle="collapse"
                                        data-parent="#accordion"
                                        :href="'#collapse-' + index"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        <b>{{ log.created | formatDate }}:</b> {{ log.message }}
                                    </a>
                                </h4>
                            </div>
                            <div :id="'collapse-' + index" class="panel-collapse collapse" role="tabpanel">
                                <div class="panel-body">
                                    {{ log.details }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ct-action">
                <div class="ct-row two-elements">
                    <div>
                        <label for="comment">
                            {{ $t('support.registrationDetails.comment') }}
                        </label>
                        <input name="comment" type="text" v-model="comment" id="comment" />
                        <button class="btn btn-success" v-on:click="addComment()">
                            {{ $t('support.registrationDetails.addcomment') }}
                        </button>
                        <button
                            class="btn btn-success"
                            v-on:click="markDone()"
                            v-if="correspondingTab === 'error' || correspondingTab === 'pending'"
                        >
                            {{ $t('support.registrationDetails.markdone') }}
                        </button>
                        <button
                            class="btn btn-success"
                            v-on:click="proceedInstallation()"
                            v-if="correspondingTab === 'pending'"
                        >
                            {{ $t('support.registrationDetails.proceedinstallation') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="ct-action">
                <div class="ct-row two-elements">
                    <div></div>
                </div>
            </div>
            <div class="ct-action" v-if="registration.duplicates">
                <div class="ct-row two-elements">
                    <div>
                        <label for="sendMail">
                            <span>{{ $t('support.registrationDetails.sendNotice') }}</span>
                            <input name="sendMail" type="checkbox" v-model="sendMail" id="sendMail" />
                        </label>
                        <button class="btn btn-danger" v-on:click="isDuplicate()">
                            {{ $t('support.registrationDetails.isDuplicate') }}
                        </button>
                    </div>
                    <button class="btn btn-success" v-on:click="noDuplicate()">
                        {{ $t('support.registrationDetails.noDuplicate') }}
                    </button>
                </div>
            </div>
        </div>
        <duplicates></duplicates>
    </div>
</template>
<script>
import Duplicates from './Duplicates.vue';
import SetupState from './SetupState.vue';

export default {
    components: { Duplicates, SetupState },
    data: function() {
        return {
            sendMail: false,
            comment: ''
        };
    },
    computed: {
        registration() {
            return this.$store.getters['support/loadedRegistration'];
        },
        correspondingTab() {
            const setupStatus = this.registration.setupStatus;
            if (setupStatus === -10) {
                return 'possibleduplicate';
            } else if (setupStatus === 0) {
                return 'pending';
            } else if (setupStatus < 0) {
                return 'error';
            } else if (setupStatus < 60) {
                return 'inprogress';
            } else if (setupStatus === 60) {
                return 'done';
            } else if (setupStatus === 110) {
                return 'done';
            }
            return '';
        }
    },
    mounted() {
        this.loadRegistrationById(this.$route.params.id);
    },
    methods: {
        loadRegistrationById(id) {
            this.$store.dispatch('support/loadRegistrationById', { id: id });
        },
        isDuplicate() {
            this.$store.dispatch('support/isDuplicate', { id: this.$route.params.id, sendMail: this.sendMail });
        },
        noDuplicate() {
            this.$store.dispatch('support/noDuplicate', { id: this.$route.params.id });
        },
        markDone() {
            this.$store.dispatch('support/markDone', { id: this.$route.params.id, comment: this.comment });
            this.comment = '';
        },
        proceedInstallation() {
            this.$store.dispatch('support/proceedInstallation', {
                id: this.$route.params.id,
                validationToken: this.registration.validationToken,
                comment: this.comment
            });
            this.comment = '';
        },
        addComment() {
            this.$store.dispatch('support/addComment', { id: this.$route.params.id, comment: this.comment });
            this.comment = '';
        }
    }
};
</script>
